import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { HistoryApiMessage, Message } from '../models/message';
import { mapHistoryMessage } from '../helpers/history-mapper';

interface ConversationHistoryResponse {
  messages: HistoryApiMessage[];
}

@Injectable({ providedIn: 'root' })
export class MessageHistoryService {
  private http = inject(HttpClient);

  fetchConversation(a: string, b: string): Observable<Message[]> {
    return this.http.post<ConversationHistoryResponse>(
      `https://${environment.messagingApi}/conversation-history`,
      { a, b }
    ).pipe(
      map(res =>
        res.messages
          .map(mapHistoryMessage)
          .sort((x, y) =>
            (x.sentTimestamp ?? x.receivedTimestamp ?? new Date()).getTime() -
            (y.sentTimestamp ?? y.receivedTimestamp ?? new Date()).getTime()
          )
      )
    );
  }

}
